const recaptchaSiteKey = '6LcQ6ZgqAAAAAAkw8rkZHd1LBRa9lIe_F7UAQ6OW';

export default recaptchaSiteKey;
